module.exports = __webpack_public_path__ + "102e56b0d63ab066b2e2224e12557a81.png";